// @ts-ignore
window.ReactOnRails = window.ReactOnRails || require('react-on-rails').default;

import './shared-api';

import React, { Suspense } from 'react';
import Header from '@/components/Header';
import CallManager from '@/components/CallManagerApp';

// App component gets registered on every app route,
// but its code will only download once it is rendered on one of the React routes
const LazyApp = React.lazy(() => import(/* webpackPrefetch: true */'@/components/App'));
const App = (props: React.ComponentProps<typeof LazyApp>) =>
  React.createElement(Suspense, { fallback: null }, React.createElement(LazyApp, props));

// Registered here rather than in a page pack: a second deferred pack can lose the race with ReactOnRails' first render pass
const LazyTrialPhoneGate = React.lazy(() => import('@/components/subcomponents/trial/TrialPhoneGate').then((m) => ({ default: m.TrialPhoneGate })));
const TrialPhoneGate = (props: React.ComponentProps<typeof LazyTrialPhoneGate>) =>
  React.createElement(Suspense, { fallback: null }, React.createElement(LazyTrialPhoneGate, props));

// @ts-ignore
window.ReactOnRails.register({ Header, App, CallManager, TrialPhoneGate });
